/* eslint-disable eqeqeq */
import { Component } from "react";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import moment, { Moment } from "moment";
import { IBodyshopService } from "../../UserService";
import {
  Box,
  Grid,
  GridItem,
  Skeleton,
  Tag,
  TagLabel,
  Text
} from "@chakra-ui/react";
import { Appointment } from "../../modals/Appointment";
import React from "react";
import IBSService from "../../Services/IBSService";
import APIService from "../../Services/APIService";
import "./styles.scss";
import { JobEstimationDetail } from "../../modals/JobEstimationDetail";
import { BookingAllowance } from "../../modals/BookingAllowance";
import CustomPopover from "../../CustomPopover/CustomPopover";
import { Mixpanel } from "../../Services/MixPanel";

require("../Booking.css");
export interface bookingCalendarProps {
  estimateDetails: JobEstimationDetail;
  ibsService: IBodyshopService;
  availableAppointments: Appointment[];
  selectedDate?: Moment | null;
  onDateSelected: (date: any) => void;
  bookingAllowance: BookingAllowance;
}
export interface bookingCalendarState {
  dropoffSelectedDate: any;
  pickupSelectedDate: any;
  showBookingSuccessMessage: boolean;
  showHireCarDialog: boolean;
  showUberDialog: boolean;
  isBookingRequested: boolean;
  selectedDate?: any;
  bookingAllowance: BookingAllowance;
  workingDays: number;
}
export default class BookingCalendar extends Component<
  bookingCalendarProps,
  bookingCalendarState
> {
  private IBSService = new IBSService();
  private apiService = new APIService();
  datetimeRef: any;

  constructor(props: bookingCalendarProps) {
    super(props);
    let isBooked =
      this.props.estimateDetails.jobNumber > 0 ||
      !this.props.ibsService.isLinkOpenedFromEmail;
    let selectedDropOffDate =
        this.props.estimateDetails.jobBookingId &&
        this.props.estimateDetails?.expectedStart
          ? moment(this.props.estimateDetails.expectedStart)
          : null,
      selectedPickupDate =
        this.props.estimateDetails.jobBookingId &&
        this.props.estimateDetails.expectedPickup
          ? moment(this.props.estimateDetails.expectedPickup)
          : null;

    this.state = {
      dropoffSelectedDate: selectedDropOffDate,
      pickupSelectedDate: selectedPickupDate,
      showBookingSuccessMessage: false,
      isBookingRequested: isBooked,
      showHireCarDialog: false,
      showUberDialog: false,
      selectedDate: this.props.selectedDate,
      bookingAllowance: this.props.bookingAllowance,
      workingDays: 0
    };
  }

  async componentDidMount() {}

  componentDidUpdate(prevProps: bookingCalendarProps) {
    if (
      prevProps.estimateDetails.jobBookingId !=
      this.props.estimateDetails.jobBookingId
    ) {
      let isRequested = this.props.estimateDetails.jobBookingId != null;
      this.setState({
        dropoffSelectedDate:
          isRequested && this.props.estimateDetails.expectedArrival
            ? moment(this.props.estimateDetails.expectedArrival)
            : null,
        pickupSelectedDate:
          isRequested && this.props.estimateDetails.expectedPickup
            ? moment(this.props.estimateDetails.expectedPickup)
            : null,
        isBookingRequested: isRequested,
        showHireCarDialog: false,
        showUberDialog: false,
        bookingAllowance: this.props.bookingAllowance
      });
      this.setState({
        bookingAllowance: this.props.bookingAllowance
      });
    }

    this.setCalendarDate();
    this.selectFirstAppointment();
  }

  selectFirstAppointment() {
    if (
      !this.state.dropoffSelectedDate &&
      this.props.availableAppointments.length > 0
    ) {
      this.onDateSelected(moment(this.props.availableAppointments[0].dueDate));
    }
  }

  onDateSelected = (date: any) => {
    this.setState({
      selectedDate: date,
      dropoffSelectedDate: date
    });
    this.props.onDateSelected(date);
  };

  fetchEstimatedPickupDate = () => {
    const {
      estimatedArrivalStartInterval,
      estimatedCompletion,
      estimatedCompletionCollectionInterval
    } = this.props.bookingAllowance;
    const numWorkingDays =
      estimatedCompletion +
      estimatedArrivalStartInterval +
      estimatedCompletionCollectionInterval;
    if (this.state.selectedDate) {
      let currentDate = moment(this.state.selectedDate);
      let remainingWorkingDays = numWorkingDays;
      let days = 0;
      while (remainingWorkingDays > 0) {
        currentDate = currentDate.add(1, "day");
        if (currentDate.day() >= 1 && currentDate.day() <= 5) {
          remainingWorkingDays--;
        }
        days++;
      }

      return { date: currentDate.format("DD/MM/YYYY"), days };
    } else {
      return { date: "", days: 0 };
    }
  };

  phoneCallEvent() {
    Mixpanel.track("Phone Call", {
      status: "Event trigger from booking calendar"
    });
  }

  render() {
    const pickUpObject = this.fetchEstimatedPickupDate();
    return (
      <Grid
        templateColumns={["repeat(1, auto)", "repeat(2, 1fr)"]}
        className="section-wrapper"
        gap="2"
      >
        <Text
          style={{ fontWeight: "bolder" }}
          as={GridItem}
          colSpan={1}
          mb={1}
          padding={"5px"}
        >
          Upcoming available dates
        </Text>

        <Text as={GridItem} colSpan={1} mb={1} className="estimated-pickup">
          <CustomPopover
            mainContent={
              <div className="d-flex justify-content-between">
                <div className="px-2">
                  {" "}
                  Estimated Pick-Up Time:{" "}
                  {this.state.selectedDate
                    ? pickUpObject.date
                    : "No date selected"}
                </div>
                <div className="px-2">
                  {this.state.selectedDate ? "Days: " + pickUpObject.days : ""}
                </div>
              </div>
            }
            bodyContent={
              <>
                <span style={{ width: "100%" }}>
                  This is an estimate only and repair times may vary. For more
                  information please{" "}
                  <a
                    href="tel:0733543711"
                    onClick={() => this.phoneCallEvent()}
                  >
                    {" call for assistance"}
                  </a>
                </span>
              </>
            }
          ></CustomPopover>
        </Text>
        <Grid
          as={GridItem}
          colSpan={[2, 1]}
          templateColumns={"repeat(2, 1fr)"}
          gap={2}
          mb={2}
        >
          {this.props.availableAppointments?.length <= 0 &&
            [...Array(6)].map((e, i) => (
              <Skeleton borderRadius={4} height="20px" key={i} />
            ))}
          {this.props.availableAppointments &&
            this.props.availableAppointments?.map(
              (date: any, index: number) => {
                if (index < 6) {
                  return (
                    <Tag
                      onClick={() => this.onDateSelected(moment(date.dueDate))}
                      as={GridItem}
                      w="100%"
                      size={"md"}
                      minW={"auto"}
                      maxH={"50px"}
                      cursor={"pointer"}
                      variant="solid"
                      colorScheme="blue"
                      background={
                        moment(this.props.selectedDate).isSame(
                          date.dueDate,
                          "day"
                        )
                          ? "blue.800"
                          : "blue.300"
                      }
                      fontWeight="bold"
                      justifyContent={"center"}
                      key={index}
                    >
                      <TagLabel>
                        {moment(date.dueDate).format("ddd - DD/MM")}
                      </TagLabel>
                    </Tag>
                  );
                }

                return "";
              }
            )}
        </Grid>
        <Box as={GridItem} colSpan={[2, 1]}>
          <Datetime
            ref={(ref) => (this.datetimeRef = ref)}
            value={this.state.dropoffSelectedDate}
            open={true}
            input={false}
            renderDay={(props, currDate, selectedDate) => {
              if (
                this.props.availableAppointments.filter((x) =>
                  currDate.startOf("day").isSame(x.dueDate, "day")
                ).length > 0
              ) {
                props.className += " availableDates";
              }

              if (
                this.state.selectedDate &&
                currDate.startOf("day").isSame(this.state.selectedDate, "day")
              ) {
                props.className += " selectedDate";
              }
              return (
                <td {...props}>
                  <span {...props} className="innerDate">
                    {currDate.date()}
                  </span>
                </td>
              );
            }}
            isValidDate={(currentDate, selectedDate) => {
              if (
                this.props.availableAppointments.filter((x) =>
                  currentDate.startOf("day").isSame(x.dueDate, "day")
                ).length === 0
              ) {
                return false;
              } else {
                return true;
              }
            }}
            onChange={this.onDateSelected}
          />
        </Box>
      </Grid>
    );
  }

  setCalendarDate() {
    const firstAppointment = moment(
      this.props.availableAppointments[0]?.dueDate
    );

    if (firstAppointment.month() !== moment().month()) {
      const month = moment(firstAppointment).startOf("month").toDate();
      this.datetimeRef.setViewDate(month);
    }
  }
}
